module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    attrs: {
      "id": "diagnostic"
    }
  }, [(_vm.isSubmitted) ? _c('div', {
    staticClass: "pendingLayer"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "is-fullhd",
    staticStyle: {
      "margin-bottom": "1rem"
    }
  }, [_c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "content progress-result has-text-right"
  }, [_c('strong', {
    staticClass: "has-text-primary"
  }, [_vm._v(_vm._s(_vm.currentStep))]), _vm._v(" out of "), _c('strong', {
    staticClass: "has-text-primary"
  }, [_vm._v(_vm._s(_vm.totalSteps))]), _vm._v(" "), _c('progress', {
    staticClass: "progress is-primary",
    attrs: {
      "max": _vm.totalSteps
    },
    domProps: {
      "value": _vm.currentStep
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "is-fullhd"
  }, [_c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.step === 1) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[0].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.identifySponsor),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update1
    }
  }), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.identifySponsor),
      expression: "identifySponsor"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.identifySponsor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.identifySponsor = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(3)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[1].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.visionClarity),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update2
    }
  }), _vm._v(" "), _vm._m(5)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visionClarity),
      expression: "visionClarity"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.visionClarity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.visionClarity = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(6)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[2].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.sponsoringCoalition),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update3
    }
  }), _vm._v(" "), _vm._m(8)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsoringCoalition),
      expression: "sponsoringCoalition"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.sponsoringCoalition)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsoringCoalition = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(9)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 4) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[3].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.sponsorCapability),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update4
    }
  }), _vm._v(" "), _vm._m(11)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsorCapability),
      expression: "sponsorCapability"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.sponsorCapability)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsorCapability = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(12)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 5) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[4].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.governance),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update5
    }
  }), _vm._v(" "), _vm._m(14)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.governance),
      expression: "governance"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.governance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.governance = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(15)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 6) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                 " + _vm._s(_vm.risks[5].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.programmeManagement),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update6
    }
  }), _vm._v(" "), _vm._m(17)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.programmeManagement),
      expression: "programmeManagement"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.programmeManagement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.programmeManagement = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(18)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 7) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[6].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.budgetingandResourcing),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update7
    }
  }), _vm._v(" "), _vm._m(20)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetingandResourcing),
      expression: "budgetingandResourcing"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.budgetingandResourcing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.budgetingandResourcing = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(21)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 8) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[7].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.programmeDelivery),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update8
    }
  }), _vm._v(" "), _vm._m(23)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.programmeDelivery),
      expression: "programmeDelivery"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.programmeDelivery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.programmeDelivery = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(24)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 9) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[8].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.businessRequirements),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update9
    }
  }), _vm._v(" "), _vm._m(26)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.businessRequirements),
      expression: "businessRequirements"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.businessRequirements)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.businessRequirements = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(27)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 10) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[9].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.organizationDesign),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update10
    }
  }), _vm._v(" "), _vm._m(29)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organizationDesign),
      expression: "organizationDesign"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.organizationDesign)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organizationDesign = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(30)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 11) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[10].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.changeReadiness),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update11
    }
  }), _vm._v(" "), _vm._m(32)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeReadiness),
      expression: "changeReadiness"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.changeReadiness)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.changeReadiness = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(33)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 12) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(34), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[11].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.implementationPlanning),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update12
    }
  }), _vm._v(" "), _vm._m(35)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.implementationPlanning),
      expression: "implementationPlanning"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.implementationPlanning)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.implementationPlanning = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(36)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 13) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                 " + _vm._s(_vm.risks[12].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.changeLeadership),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update13
    }
  }), _vm._v(" "), _vm._m(38)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.changeLeadership),
      expression: "changeLeadership"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.changeLeadership)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.changeLeadership = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(39)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 14) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(40), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[13].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.stakeholderEngagement),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update14
    }
  }), _vm._v(" "), _vm._m(41)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stakeholderEngagement),
      expression: "stakeholderEngagement"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.stakeholderEngagement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stakeholderEngagement = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(42)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 15) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(43), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[14].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.implementationCapability),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update15
    }
  }), _vm._v(" "), _vm._m(44)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.implementationCapability),
      expression: "implementationCapability"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.implementationCapability)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.implementationCapability = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(45)], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 16) ? _c('div', [_c('div', {
    staticClass: "column"
  }, [_vm._m(46), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "has-text-weight-semibold has-text-justified"
  }, [_vm._v("\n                  " + _vm._s(_vm.risks[15].question) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-9 secSlider"
  }, [_c('slider', {
    staticClass: "diagSlider",
    attrs: {
      "type": "success",
      "value": parseFloat(_vm.supportPeoplesJournery),
      "min": 1,
      "max": 9,
      "step": .5,
      "is-fullwidth": ""
    },
    on: {
      "change": _vm.update16
    }
  }), _vm._v(" "), _vm._m(47)], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-3",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supportPeoplesJournery),
      expression: "supportPeoplesJournery"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9",
      "step": ".5",
      "value": "",
      "onkeyup": "this.value > 9 ? this.value = this.value.slice(0, -1) : true"
    },
    domProps: {
      "value": (_vm.supportPeoplesJournery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.supportPeoplesJournery = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-tablet"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile is-one-third-desktop is-paddingless legend"
  }, [_c('Label', [_vm._v("Legend")]), _vm._v(" "), _vm._m(48)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column content progress-btn is-hidden-mobile"
  }, [_c('div', {
    staticClass: "buttons",
    class: {
      'btnRight': _vm.currentStep === 1
    }
  }, [(_vm.currentStep > 1) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), (_vm.currentStep < _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next()
      }
    }
  }, [_vm._v("Next  "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.currentStep === _vm.totalSteps) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal successModal",
    class: {
      isActive: _vm.modalOpen
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "is-title is-bold has-text-centered has-text-primary"
  }, [_vm._v("\n            Thank you!\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n          Your submission has been received! When all participants have submitted their scores, you can access the team scores.\n        ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_vm._v("\n          Thank you for using ChangeVU!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("OK")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "has-text-white has-text-weight-bold"
  }, [_vm._v("\n        Your submission has been received! When all participants have submitted their scores, you will receive a message to access the team scores.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', {
    staticClass: "has-text-primary"
  }, [_vm._v("\n                  Change risk factor\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagSliderLabel"
  }, [_c('span', {}, [_vm._v("1")]), _vm._v(" "), _c('span', {}, [_vm._v("3")]), _vm._v(" "), _c('span', {}, [_vm._v("5")]), _vm._v(" "), _c('span', {}, [_vm._v("7")]), _vm._v(" "), _c('span', {}, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend-labels"
  }, [_c('li', [_vm._v("1 - 3 "), _c('span', {
    staticClass: "colorGreen"
  }), _c('strong', [_vm._v(" Low Risk")])]), _vm._v(" "), _c('li', [_vm._v("4 - 6 "), _c('span', {
    staticClass: "colorYellow"
  }), _c('strong', [_vm._v(" Medium Risk")])]), _vm._v(" "), _c('li', [_vm._v("7 - 9 "), _c('span', {
    staticClass: "colorRed"
  }), _c('strong', [_vm._v(" High Risk")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04e956b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/assessment/riskAssessment.vue
// module id = 355
// module chunks = 5